import { Card } from "../../../../../../components/Card";
import { Accordion, Grid, GridItem, Heading } from "@chakra-ui/react";
import { IconTitle } from "../../../../../../components/IconTitle";
import NumberField from "../../../../../../components/NumberField/NumberField";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { MissingDataLabel } from "../../../../components/MissingDataLabel";
import { TotalReportGridAccordionItem } from "./index";

function ScopeSection({ title, data, totalEntity }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });

  return (
    <Card boxShadow="xs">
      <Heading size="md" marginBlock="1">
        {title}
      </Heading>

      <Accordion
        defaultIndex={[0]} allowMultiple marginTop="10"
        marginBottom={totalEntity && totalEntity.value > 0 ? "10" : "0"}
      >
        {Object.keys(data).map(emissionsKey => {
          return data[emissionsKey].items?.length > 0 ?
            <TotalReportGridAccordionItem
              key={`accordion-item-${emissionsKey}`}
              data={data}
              title={t(`${emissionsKey}Title`)}
              type={emissionsKey}
            /> : null;
        })}
      </Accordion>

      {totalEntity && totalEntity.value > 0 && <Grid templateColumns="repeat(2, 1fr)" gap={2} overflow="auto">
        <GridItem>
          <IconTitle
            icon={undefined}
            title={totalEntity.title}
            subTitle={totalEntity.subTitle}
          />
        </GridItem>
        <GridItem>
          <NumberField fontWeight="bold" value={totalEntity.value} />
        </GridItem>
      </Grid>}

      {(!data || Object.keys(data).length === 0 ||
        typeof Object.keys(data).find(key => data[key].items?.length > 0) === "undefined") &&
        <MissingDataLabel />
      }
    </Card>
  );
}

export default ScopeSection;